module.exports = __webpack_public_path__ + "img/link-handbook-desktop_en.d25ff73.jpg";